import Bugsnag from '@bugsnag/js';
import isEmpty from 'lodash/isEmpty';

export const getCenter = ({ ne_lat, ne_lng, sw_lat, sw_lng }, lat?, lng?, searchResultsMeta?) => {
  if ((lat || lng) && lat !== 0 && lng !== 0) {
    return {
      lng,
      lat,
    };
  }

  if (searchResultsMeta) {
    if (searchResultsMeta?.geography?.original) {
      // eslint-disable-next-line no-unsafe-optional-chaining
      const { lat: lLat, lng: lLng } = searchResultsMeta?.geography?.original;
      return {
        lat: parseFloat(lLat),
        lng: parseFloat(lLng),
      };
    }
  }

  const center = boxCenter([
    [sw_lat, sw_lng],
    [ne_lat, ne_lng],
  ]);

  return center.reduce((acc: any, el, i) => {
    if (i) {
      acc.lng = el;
    } else {
      acc.lat = el;
    }
    return acc;
  }, {});
};

export const boxCenter = (box) => {
  const x = box.map((xy) => xy[0]);
  const y = box.map((xy) => xy[1]);
  const cx = (Math.min(...x) + Math.max(...x)) / 2;
  const cy = (Math.min(...y) + Math.max(...y)) / 2;
  return [cx, cy];
};

export const tokenizeSearchLocationString = (location: string) => {
  // Here we indroduced a try catch block, do we still need the isEmpty? Or in this case always return locationstring
  try {
    const locationString = location.split(',').map((t) => t.toLowerCase().trim());
    return isEmpty(location) ? [] : locationString;
  } catch (err) {
    Bugsnag.notify(err);
    return [];
  }
};

// @ts-ignore
export const locationIsDomesticSearch = (tokens: Array, near?: string) =>
  tokens.some((el) => el === 'usa' || el === 'us' || el === 'usvi' || el.includes('u.s.') || el === 'united states') ||
  near?.toLowerCase()?.includes('united states') ||
  isVirginIsland(tokens, near);

const isVirginIsland = (tokens: string[], near: string) =>
  near?.toLowerCase().includes('virgin islands') &&
  !tokens.some((e) => e.includes('uk')) &&
  !tokens.some((e) => e.includes('british'));
